<template>
    <div class="card card-admin">
        <div class="newCategory-title">
            <h1>Aggiungi una nuova categoria</h1>
        </div>
        <div class="card-body">
            <div class="form-group">
                <img class="img-thumbnail image-preview" :src="category.backgroundImage" v-if="category.backgroundImage"
                    alt="Anteprima immagine" />
                <p style="text-align: center;" v-else>Anteprima immagine non disponibile</p>
            </div>
            <div class="form-group">
                <label for="title">Titolo categoria:</label>
                <input type="text" class="form-control" id="title" v-model="category.title"
                    placeholder="Inserisci il titolo della categoria" />
            </div>
            <div class="form-group">
                <ImageUploader @image-selected="handleFileSelected" />
            </div>
            <div class="button-group">
                <button class="btn btn-primary apply-button" @click="handleCreateNewCategory">Aggiungi nuova
                    categoria</button>
            </div>
        </div>
    </div>
</template>

<script>
import { createCategory } from '@/api/CategoryAPI';
import { uploadImage } from '@/utils/firebaseImageUploader';
import ImageUploader from '@/components/adminpage/ImageUploader.vue';

export default {
    components: {
        ImageUploader,
    },
    data() {
        return {
            category: {
                backgroundImage: '',
                title: '',
            },
        };
    },
    methods: {
        handleFileSelected(file) {
            this.category.backgroundImage = file;
        },
        async handleCreateNewCategory() {
            try {
                if (this.category.backgroundImage) {
                    const imageurl = await uploadImage(this.category.backgroundImage);
                    this.category.backgroundImage = imageurl;
                }
                await createCategory(this.category);
                this.$emit('new-category-created')
            } catch (error) {
                console.error('Errore durante la creazione della nuova categoria:', error);
            }
        }
    }
};
</script>

<style scoped>
.card-admin {
    padding-top: 30px;
    border: none;
    background-color: transparent;
    margin: 20px;
    margin-bottom: 0px;
    padding-bottom: 30px;
}

.form-group {
    margin-bottom: 20px;
    padding-left: 15px;
    padding-right: 15px;
}

.apply-button,
.delete-button {
    margin: auto;
}

.image-preview {
    max-width: 100%;
    height: auto;
    display: block;
    margin: auto;
}

.card-body {
    color: var(--text-color);
    background-color: var(--secondary-color);
    box-shadow: var(--custom-box-shadow);
    border-radius: 20px;
}

.button-group {
    display: flex;
    margin-top: 40px;
    margin-bottom: 15px;
}

.newCategory-title {
    color: var(--text-color);
    background-color: var(--accent-color);
    text-align: center;
    margin: auto;
    margin-bottom: 20px;
    border-radius: 25px;
    border: solid 2px;
    border-color: var(--border-color);
    box-shadow: var(--custom-box-shadow);
}

.newCategory-title h1 {
    padding: 10px;
}
</style>